// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'sport1RegularItalic', Sport1-RegularItalic-Fallback"},"className":"__className_b6797d"};